module.exports = __webpack_public_path__ + "static/img/banner.5d558cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.jpg
// module id = oxzm
// module chunks = 1